<script>
  import Modal from "./../../../shared/Modal.svelte";
  import config from "./../../../stores/config";
  import { Circle } from "svelte-loading-spinners";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import * as ls from "local-storage";

  const dispatch = createEventDispatcher();
  const authData = { headers: { authorization: ls.get("jwt") } };

  export let styleID;
  export let itemID;
  export let _id;
  export let qtyReq;
  export let uPrice;

  let derivedName = $config?.items?.find(({ value }) => value == itemID)?.label;
  let stockType = $config?.items?.find(
    ({ value }) => value == itemID
  )?.stockType;
  let colour = $config?.items?.find(({ value }) => value == itemID)?.colour;

  let editedMat = {
    itemID,
    qtyReq,
    uPrice,
  };

  let showEditMatForm = false;
  let editMatLoading = false;

  const handleEditStyle = async (e) => {
    if (editedMat.qtyReq == undefined) alert("⚠ Qty Needed missing!");
    else {
      editMatLoading = true;

      let data = { ...editedMat };

      axios
        .put(
          `${$config.backendURL}/fstyles/${styleID}/edit-material/${_id}`,
          data,
          authData
        )
        .then((res) => {
          showEditMatForm = false;
          editMatLoading = false;
          setTimeout(() => {
            dispatch("update");
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete ${derivedName}?`);

    if (confirmDelete) {
      axios
        .delete(
          `${$config.backendURL}/fstyles/${styleID}/delete-material/${_id}`,
          authData
        )
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };
</script>

<div class="tr tracking-wider border-b border-gray-100 ">
  <div style="min-width: 10rem; max-width: 10rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <button
      class="text-base btn btn-green-outline mr-2"
      on:click={(e) => (showEditMatForm = true)}
    >
      <i class="fas fa-edit" />
    </button>
  </div>
  <div style="min-width: 15rem; max-width: 15rem;">{derivedName}</div>
  <div style="min-width: 7rem; max-width: 7rem;">{qtyReq}</div>
  <div style="min-width: 10rem; max-width: 10rem;">{colour || "N/A"}</div>
  <div style="min-width: 7rem; max-width: 7rem;">{stockType}</div>
  <div style="min-width: 7rem; max-width: 7rem;">R{uPrice}</div>
  <div style="min-width: 7rem; max-width: 7rem;">
    R{(uPrice * qtyReq).toFixed(2)}
  </div>
</div>

<!-- EDIT MODAL -->
<Modal
  show={showEditMatForm}
  on:modalClose={() => {
    showEditMatForm = false;
  }}
>
  <div class="grid gap-y-2">
    <div class="flex items-center uppercase">
      <i class="text-green-400 fas fa-exclamation-circle text-xl mr-2" />
      <div class="col-span-2 text-base">
        {derivedName}
      </div>
    </div>

    <div class="grid grid-cols-3 gap-2 items-center">
      <div>Quantity Required :</div>
      <input
        class="col-span-2"
        bind:value={editedMat.qtyReq}
        type="number"
        step="any"
        placeholder="Quantity or meters required"
      />
    </div>

    {#if editMatLoading}
      <div class="flex items-center justify-center btn btn-green-outline">
        <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
        <span class="ml-4">Please wait...</span>
      </div>
    {:else}
      <!-- else content here -->
      <div class="flex">
        <button
          style="width: 100%;"
          class="btn btn-green"
          on:click={handleEditStyle}
        >
          <i class="fas fa-check-circle mr-3" />
          Save
        </button>
        <button
          style="width: 100%;"
          class="ml-4 btn btn-gray"
          on:click={(e) => (showEditMatForm = false)}
        >
          <i class="fas fa-times-circle mr-3" />
          Close
        </button>
      </div>
    {/if}
  </div>
</Modal>

<!-- EDIT MODAL -->
<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }
</style>
